import script from "./UploadCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadCategory.vue?vue&type=script&setup=true&lang=js"

import "./UploadCategory.vue?vue&type=style&index=0&id=1c8004b0&lang=css"

const __exports__ = script;

export default __exports__